/*
 * Destination Messages
 *
 * This contains all the text for the Staff container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Destination';

export default defineMessages({
  header: {
    id: `${scope}.destination`,
    defaultMessage: 'This is the Destination container!',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Destinations',
  },
  new_destination: {
    id: `${scope}.new_destination`,
    defaultMessage: 'New destination',
  },
  customerCode: {
    id: `${scope}.customerCode`,
    defaultMessage: 'Cust. Code',
  },
  customerCodeSearch: {
    id: `${scope}.customerCodeSearch`,
    defaultMessage: 'Customer Code',
  },
  destinationState: {
    id: `${scope}.destinationState`,
    defaultMessage: 'Dest. State',
  },
  destinationStateSearch: {
    id: `${scope}.destinationStateSearch`,
    defaultMessage: 'Destination State',
  },
  destinationCode: {
    id: `${scope}.destinationCode`,
    defaultMessage: 'Dest. Code',
  },
  destinationCodeSearch: {
    id: `${scope}.destinationCodeSearch`,
    defaultMessage: 'Destination Code',
  },
  businessName: {
    id: `${scope}.businessName`,
    defaultMessage: 'Dest. Area',
  },
  destinationLogisticArea: {
    id: `${scope}.destinationLogisticArea`,
    defaultMessage: 'Customer Dest. Logistic Area',
  },
  destinationLogisticAreaSearch: {
    id: `${scope}.destinationLogisticAreaSearch`,
    defaultMessage: 'Customer Destination Logistic Area',
  },
  businessCity: {
    id: `${scope}.businessCity`,
    defaultMessage: 'City',
  },
  businessProvince: {
    id: `${scope}.businessProvince`,
    defaultMessage: 'Province',
  },
  businessCountry: {
    id: `${scope}.businessCountry`,
    defaultMessage: 'Country',
  },
  nominative: {
    id: `${scope}.nominative`,
    defaultMessage: 'Nominative',
  },
  export_pdf: {
    id: `${scope}.export_pdf`,
    defaultMessage: 'Export PDF',
  },
  address: {
    id: `${scope}.address`,
    defaultMessage: 'Address',
  },
  prospect: {
    id: `${scope}.prospect`,
    defaultMessage: 'Prospect',
  },
  customer: {
    id: `${scope}.client`,
    defaultMessage: 'Customer',
  },
  type: {
    id: `${scope}.type`,
    defaultMessage: 'Type of customer',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Phone',
  },
  agent: {
    id: `${scope}.agent`,
    defaultMessage: 'Agent',
  },
  ACTIVE: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
  INACTIVE: {
    id: `${scope}.inactive`,
    defaultMessage: 'Inactive',
  },
  onlyMine: {
    id: `${scope}.onlyMine`,
    defaultMessage: 'Only mine',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Yes',
  },
  lastAction: {
    id: `${scope}.lastAction`,
    defaultMessage: 'Last action',
  },
  shopSign: {
    id: `${scope}.shopSign`,
    defaultMessage: 'Shop sign',
  },
});
